<template>
  <b-modal
    id="edit-Remitter-credit"
    size="lg"
    title="Edit Remmiter Credit"
    no-stacking
    no-close-on-backdrop
    hide-footer
  >
    <div class="modal-area">
      <ValidationObserver v-slot="{ passes }">
        <form @submit.prevent="passes(editremitterCredit)" id="basic-form">
          <ValidationProvider
            name="customer"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="country-dropdown">
              <div
                class="form-group form-select multiselect-grp"
                :class="{
                  errors: errors.length && !remitterCredit.customer,
                  success: remitterCredit.customer,
                }"
              >
                <span class="float-label">
                  <label for="customer">Select Customer</label>
                  <v-select
                    :options="customersoptions"
                    multiple
                    v-model="remitterCredit.customer"
                    disabled
                  ></v-select>
                  <div class="line"></div>
                  <i
                    class="fa fa-times"
                    v-if="errors.length && !remitterCredit.customer"
                  ></i>
                  <i class="fa fa-check" v-if="remitterCredit.customer"></i>
                </span>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="amount"
            rules="required"
            v-slot="{ errors }"
          >
            <div
              class="form-group d-flex"
              :class="{
                errors: errors.length && !remitterCredit.amount,
                success: remitterCredit.amount,
              }"
            >
              <span class="float-label flex-grow-1 mr-2">
                <input
                  type="text"
                  v-model="remitterCredit.amount"
                  class="form-control"
                  id="amount"
                  placeholder="Company Name*"
                  :disabled="!editAmount"
                  @keypress="onlyNumber($event)"
                />
                <label for="amount" class="control-label">
                  Update the Amount added to Wallet*
                </label>
                <div class="line"></div>
                <i
                  class="fa fa-times"
                  v-if="errors.length && !remitterCredit.amount"
                ></i>
                <i class="fa fa-check" v-if="remitterCredit.amount"></i>
              </span>
              <b-button
                class="fliter-btn"
                variant="outline-secondary"
                @click="editAmount = !editAmount"
              >
                <i class="fa fa-edit" aria-hidden="true"></i>
              </b-button>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="credit_type"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="country-dropdown">
              <div
                class="form-group form-select multiselect-grp d-flex"
                :class="{
                  errors: errors[0],
                  success:
                    remitterCredit.creditType &&
                    remitterCredit.creditType.length != 0 &&
                    !errors[0],
                }"
              >
                <span class="float-label flex-grow-1 mr-2">
                  <label for="credit_type">Select Credit Type*</label>
                  <multiselect
                    placeholder=""
                    v-model="remitterCredit.creditType"
                    :show-labels="false"
                    :options="creditType_Options"
                    :searchable="false"
                    :disabled="!editCreditType"
                  ></multiselect>
                  <i class="fa fa-times" v-if="errors.length && errors[0]"></i>
                  <i
                    class="fa fa-check"
                    v-if="
                      remitterCredit.creditType &&
                      remitterCredit.creditType.length != 0 &&
                      !errors[0]
                    "
                  ></i>
                </span>
                <b-button
                  class="fliter-btn"
                  variant="outline-secondary"
                  @click="editCreditType = !editCreditType"
                >
                  <i class="fa fa-edit" aria-hidden="true"></i>
                </b-button>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="comment"
            rules="required"
            v-slot="{ errors }"
          >
            <div
              class="form-group"
              :class="{
                errors: errors.length && !remitterCredit.comment,
                success: remitterCredit.comment,
              }"
            >
              <span class="float-label">
                <textarea
                  type="text"
                  v-model="remitterCredit.comment"
                  class="form-control"
                  id="comment"
                  placeholder="Company Name*"
                ></textarea>
                <label for="comment" class="control-label">Comment*</label>
                <div class="line"></div>
                <i
                  class="fa fa-times"
                  v-if="errors.length && !remitterCredit.comment"
                ></i>
                <i class="fa fa-check" v-if="remitterCredit.comment"></i>
              </span>
            </div>
          </ValidationProvider>
          <div class="d-flex align-items-center m-b-20">
            <div class="custom-switch success-error-bg mr-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                id="customSwitch1"
                v-model="sendNotification"
              />
              <label class="custom-switch-label" for="customSwitch1">
                <span class="custom-switch-text1">Yes</span>
                <span class="custom-switch-text2">No</span>
              </label>
            </div>
            <label class="mb-0" for="customSwitch1">
              Send Notification to Customer?
            </label>
          </div>
          <h5 class="text-primary font-weight-normal mb-0">Edit Logs</h5>
          <ul class="list-unstyled mb-0 striped-list mb-2">
            <li class="p-1">
              <div class="row">
                <div class="col-md-4">
                  <span class="font-weight-bold">Arthur Curry</span>
                </div>
                <div class="col-md-4">2022-08-19 03:17:41</div>
                <div class="col-md-4">Created</div>
              </div>
            </li>
            <li class="p-1">
              <div class="row">
                <div class="col-md-4">
                  <span class="font-weight-bold">Ben Parker</span>
                </div>
                <div class="col-md-4">2022-08-19 06:37:47</div>
                <div class="col-md-4">Edited</div>
              </div>
            </li>
          </ul>
          <div class="d-flex flex-column flex-md-row justify-content-center">
            <b-button
              variant="secondary btn-mw"
              size="lg"
              @click="cancelEdit()"
            >
              Cancel
            </b-button>
            <b-button
              type="button"
              variant="danger ml-md-1 mt-2 mt-md-0 btn-mw"
              size="lg"
            >
              Voided
            </b-button>
            <b-button
              type="submit"
              variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
              size="lg"
            >
              Submit
            </b-button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </b-modal>
</template>
<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "vue-select/dist/vue-select.css";
export default {
  name: "EditRemitterCreditModel",
  components: {
    Multiselect: () => import("vue-multiselect"),
    "v-select": () => import("vue-select"),
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    remitterCredit: Object,
  },
  data() {
    return {
      sendNotification: false,
      editAmount: false,
      editCreditType: false,
      customersoptions: [
        "Adam Driver",
        "Dominic Torreto",
        "Brain O'Conner",
        "Mark Chalamet",
        "Robert Evans",
        "Emma Thomas",
        "Alizee Thomas",
        "Selena Parker",
        "Hal Chalamet",
        "Ben Murphy",
      ],
      creditType_Options: [
        "Promotional Credit",
        "Goodwill Gesture",
        "Refund",
        "Referral Credit",
        "Credit",
      ],
    };
  },
  methods: {
    editremitterCredit() {
      console.log(this.remitterCredit);
      this.sendNotification = false;
      this.editAmount = false;
      this.editCreditType = false;
      this.$bvModal.hide("edit-Remitter-credit");
    },
    // to enter only number
    onlyNumber(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
      if (/^\W$/.test(event.key)) {
        event.preventDefault();
      }
    },
    cancelEdit() {
      this.sendNotification = false;
      this.editAmount = false;
      this.editCreditType = false;
      this.$bvModal.hide("edit-Remitter-credit");
    },
  },
};
</script>
